import angular from 'angular'
import { StateProvider, UIRouter } from "@uirouter/angularjs";
import '@uirouter/angularjs';
import { AuthService } from "./libs/Auth";
import 'angular-jwt'
import 'jquery';
import 'bootstrap-sass';
import 'leaflet/dist/leaflet.css';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css'
import 'angular-ui-grid/ui-grid.css';
import '../assets/scss/app.scss'
import { EditMaintenanceHandler_EditAsset } from "./libs/EditMaintenanceHandler/EditMaintenanceHandler_EditAsset";
import { EditMaintenanceHandler_NewAsset } from "./libs/EditMaintenanceHandler/EditMaintenanceHandler_NewAsset";
import { AssetAdminPagingModel } from "./models/paging/AssetAdminPagingModel";
import { AlarmAckService } from "./services/AlarmAckService";
import { AlarmService } from "./services/AlarmService";
import { AlertingActionService } from "./services/AlertingActionService";
import { AntennaService } from "./services/AntennaService";
import { ApplicationSettingService } from "./services/ApplicationSettingService";
import { AssetService } from "./services/AssetService";
import { CheckoutHistoryService } from "./services/CheckoutHistoryService";
import { ConfigSettingService } from "./services/ConfigSettingService";
import { CustomFieldNameService } from "./services/CustomFieldNameService";
import { EmployeeService } from "./services/EmployeeService";
import { AuditService } from "./services/AuditService";
import { EventService } from "./services/EventService";
import { FileDataService } from "./services/FileDataService";
import { FixedVTagService } from "./services/FixedVTagService";
import { GpsLocationHistoryService } from "./services/GpsLocationHistoryService";
import { GridBookmarkService } from "./services/GridBookmarkService";
import { LocationHistoryService } from "./services/LocationHistoryService";
import { EmployeeLocationHistoryService } from "./services/EmployeeLocationHistoryService";
import { LocationService } from "./services/LocationService";
import { MaintenanceHistoryService } from "./services/MaintenanceHistoryService";
import { MapAreaService } from "./services/MapAreaService";
import { MapSiteService } from "./services/MapSiteService";
import { NotificationService } from "./services/NotificationService";
import { PluginService } from "./services/PluginService";
import { PrinterService } from "./services/PrinterService";
import { PrintJobService } from "./services/PrintJobService";
import { QueuedCommandService } from "./services/QueuedCommandService";
import { ReaderService } from "./services/ReaderService";
import { SensorService } from "./services/SensorService";
import { SensorStatService } from "./services/SensorStatService";
import { ServerStatusService } from "./services/ServerStatusService";
import { TemplateService } from "./services/TemplateService";
import { UserService } from "./services/UserService";
import { CheckoutModel } from "./models/tasks/CheckoutModel";
import { DisplayOptionsModel } from "./models/tasks/DisplayOptionsModel";
import { EditCustomFieldNameModel } from "./models/tasks/EditCustomFieldNameModel";
import { EditOptionsModel } from "./models/tasks/EditOptionsModel";
import { ScheduledMaintenanceModel } from "./models/tasks/ScheduledMaintenanceModel";
import { ShowTrackModel } from "./models/tasks/ShowTrackModel";
import { ReportAssetLocationHistoryModel } from "./models/reports/ReportAssetLocationHistoryModel";
import { ReportGpsLocationHistoryModel } from "./models/reports/ReportGpsLocationHistoryModel";
import { ReportAssetsModel } from "./models/reports/ReportAssetsModel";
import { ReportEmployeeWorkHoursModel } from "./models/reports/ReportEmployeeWorkHoursModel";
import { ReportCheckoutHistoryModel } from "./models/reports/ReportCheckoutHistoryModel";
import { ReportLocationHistoryModel } from "./models/reports/ReportLocationHistoryModel";
import { ReportEmployeeLocationHistoryModel } from "./models/reports/ReportEmployeeLocationHistoryModel";
import { ReportLocationModel } from "./models/reports/ReportLocationModel";
import { ReportLowBatteryModel } from "./models/reports/ReportLowBatteryModel";
import { ReportMaintenanceScheduleModel } from "./models/reports/ReportMaintenanceScheduleModel";
import { ReportVTagCommunicationModel } from "./models/reports/ReportVTagCommunicationModel";
import { AlarmAckAdminPagingModel } from "./models/paging/AlarmAckAdminPagingModel";
import { AlarmAdminPagingModel } from "./models/paging/AlarmAdminPagingModel";
import { AlertingActionAdminPagingModel } from "./models/paging/AlertingActionAdminPagingModel";
import { CommandAdminPagingModel } from "./models/paging/CommandAdminPagingModel";
import { EmployeeAdminPagingModel } from "./models/paging/EmployeeAdminPagingModel";
import { EventAdminPagingModel } from "./models/paging/EventAdminPagingModel";
import { AuditAdminPagingModel } from "./models/paging/AuditAdminPagingModel";
import { FixedVTagAdminPagingModel } from "./models/paging/FixedVTagAdminPagingModel";
import { LocationAdminPagingModel } from "./models/paging/LocationAdminPagingModel";
import { PluginAdminPagingModel } from "./models/paging/PluginAdminPagingModel";
import { PrinterAdminPagingModel } from "./models/paging/PrinterAdminPagingModel";
import { PrintJobAdminPagingModel } from "./models/paging/PrintJobAdminPagingModel";
import { ReaderAdminPagingModel } from "./models/paging/ReaderAdminPagingModel";
import { SensorAdminPagingModel } from "./models/paging/SensorAdminPagingModel";
import { SensorStatAdminPagingModel } from "./models/paging/SensorStatAdminPagingModel";
import { TemplateAdminPagingModel } from "./models/paging/TemplateAdminPagingModel";
import { UserAdminPagingModel } from "./models/paging/UserAdminPagingModel";
import { ServerAssetImportModel } from "./models/serverimport/ServerAssetImportModel";
import { ServerLocationImportModel } from "./models/serverimport/ServerLocationImportModel";
import { AssetImportModel } from "./models/import/AssetImportModel";
import { LocationImportModel } from "./models/import/LocationImportModel";
import { AssetExportModel } from "./models/export/AssetExportModel";
import { AuditExportModel } from "./models/export/AuditExportModel";
import { FixedExportModel } from "./models/export/FixedExportModel";
import { LocationExportModel } from "./models/export/LocationExportModel";
import { AssetLocationHistoriesModel } from "./models/edit/AssetLocationHistoriesModel";
import { CustomFieldNameModel } from "./models/edit/CustomFieldNameModel";
import { EditAlertingActionModel } from "./models/edit/EditAlertingActionModel";
import { EditAssetModel } from "./models/edit/EditAssetModel";
import { EditEmployeeModel } from "./models/edit/EditEmployeeModel";
import { EditFixedVTagModel } from "./models/edit/EditFixedVTagModel";
import { EditLocationModel } from "./models/edit/EditLocationModel";
import { EditScannerModel } from "./models/edit/EditScannerModel";
import { EditPluginModel } from "./models/edit/EditPluginModel";
import { EditPrinterModel } from "./models/edit/EditPrinterModel";
import { EditReaderModel } from "./models/edit/EditReaderModel";
import { EditUserModel } from "./models/edit/EditUserModel";
import { PickChildModel } from "./models/edit/PickChildModel";
import { CmdCenterAssetCmdModel } from "./models/cmd/CmdCenterAssetCmdModel";
import { CmdCenterEditAreaModel } from "./models/cmd/CmdCenterEditAreaModel";
import { CmdCenterEditOptionsModel } from "./models/cmd/CmdCenterEditOptionsModel";
import { CmdCenterEditSiteModel } from "./models/cmd/CmdCenterEditSiteModel";
import { CmdCenterMapModel } from "./models/cmd/CmdCenterMapModel";
import { CmdCenterQueuedCmdModel } from "./models/cmd/CmdCenterQueuedCmdModel";
import { CmdCenterSetPositionFixedModel } from "./models/cmd/CmdCenterSetPositionFixedModel";
import { CmdCenterSetPositionGatewayModel } from "./models/cmd/CmdCenterSetPositionGatewayModel";
import { CmdCenterShowNearestModel } from "./models/cmd/CmdCenterShowNearestModel";
import { CmdCenterSiteAreaModel } from "./models/cmd/CmdCenterSiteAreaModel";
import { AboutCtrl } from "./controllers/view/AboutCtrl";
import { AssetCheckoutHistoriesCtrl } from "./controllers/view/AssetCheckoutHistoriesCtrl";
import { AssetLocationHistoriesCtrl } from "./controllers/view/AssetLocationHistoriesCtrl";
import { AssetSensorHistoriesCtrl } from "./controllers/view/AssetSensorHistoriesCtrl";
import { GraphCtrl } from "./controllers/view/GraphCtrl";
import { ShowTrackCtrl } from "./controllers/view/ShowTrackCtrl";
import { NetworkStatusCtrl } from "./controllers/view/NetworkStatusCtrl";
import { BatchMoveCtrl } from "./controllers/tasks/BatchMoveCtrl";
import { CheckoutCtrl } from "./controllers/tasks/CheckoutCtrl";
import { DisplayOptionsCtrl } from "./controllers/tasks/DisplayOptionsCtrl";
import { EditCustomFieldNameCtrl } from "./controllers/tasks/EditCustomFieldNameCtrl";
import { EditOptionsCtrl } from "./controllers/tasks/EditOptionsCtrl";
import { PrintCtrl } from "./controllers/tasks/PrintCtrl";
import { AssetPictureCtrl } from "./controllers/tasks/AssetPictureCtrl";
import { ScheduledMaintenanceCtrl } from "./controllers/tasks/ScheduledMaintenanceCtrl";
import { ReportAssetLocationHistoryCtrl } from "./controllers/reports/ReportAssetLocationHistoryCtrl";
import { ReportGpsLocationHistoryCtrl } from "./controllers/reports/ReportGpsLocationHistoryCtrl";
import { ReportAssetsCtrl } from "./controllers/reports/ReportAssetsCtrl";
import { ReportEmployeeWorkHoursCtrl } from "./controllers/reports/ReportEmployeeWorkHoursCtrl";
import { ReportCheckoutHistoryCtrl } from "./controllers/reports/ReportCheckoutHistoryCtrl";
import { ReportLocationHistoryCtrl } from "./controllers/reports/ReportLocationHistoryCtrl";
import { ReportEmployeeLocationHistoryCtrl } from "./controllers/reports/ReportEmployeeLocationHistoryCtrl";
import { ReportLocationCtrl } from "./controllers/reports/ReportLocationCtrl";
import { ReportLowBatteryCtrl } from "./controllers/reports/ReportLowBatteryCtrl";
import { ReportMaintenanceScheduleCtrl } from "./controllers/reports/ReportMaintenanceScheduleCtrl";
import { ReportVTagCommunicationCtrl } from "./controllers/reports/ReportVTagCommunicationCtrl";
import { ImportConfirmCtrl } from "./controllers/import/ImportConfirmCtrl";
import { ImportFixErrorsCtrl } from "./controllers/import/ImportFixErrorsCtrl";
import { ImportMapFieldsCtrl } from "./controllers/import/ImportMapFieldsCtrl";
import { ImportSummaryCtrl } from "./controllers/import/ImportSummaryCtrl";
import { ImportUploadFileCtrl } from "./controllers/import/ImportUploadFileCtrl";
import { AdminPagingCtrl } from "./controllers/AdminPagingCtrl";
import { ExportCtrl } from "./controllers/export/ExportCtrl";
import { EditAlertingActionCtrl } from "./controllers/edit/EditAlertingActionCtrl";
import { EditAssetCtrl } from "./controllers/edit/EditAssetCtrl";
import { EditEmployeeCtrl } from "./controllers/edit/EditEmployeeCtrl";
import { EditFixedVTagCtrl } from "./controllers/edit/EditFixedVTagCtrl";
import { EditLocationCtrl } from "./controllers/edit/EditLocationCtrl";
import { EditScannerCtrl } from "./controllers/edit/EditScannerCtrl";
import { EditMaintenanceCtrl } from "./controllers/edit/EditMaintenanceCtrl";
import { EditPasswordCtrl } from "./controllers/edit/EditPasswordCtrl";
import { EditPluginCtrl } from "./controllers/edit/EditPluginCtrl";
import { EditPrinterCtrl } from "./controllers/edit/EditPrinterCtrl";
import { EditReaderCtrl } from "./controllers/edit/EditReaderCtrl";
import { EditTemplateCtrl } from "./controllers/edit/EditTemplateCtrl";
import { EditUserCtrl } from "./controllers/edit/EditUserCtrl";
import { PickChildCtrl } from "./controllers/edit/PickChildCtrl";
import { CmdCenterAssetCmdCtrl } from "./controllers/cmd/CmdCenterAssetCmdCtrl";
import { CmdCenterEditAreaCtrl } from "./controllers/cmd/CmdCenterEditAreaCtrl";
import { CmdCenterEditOptionsCtrl } from "./controllers/cmd/CmdCenterEditOptionsCtrl";
import { CmdCenterEditSiteCtrl } from "./controllers/cmd/CmdCenterEditSiteCtrl";
import { CmdCenterMapCtrl } from "./controllers/cmd/CmdCenterMapCtrl";
import { CmdCenterNetworkCmdCtrl } from "./controllers/cmd/CmdCenterNetworkCmdCtrl";
import { CmdCenterQueuedCmdCtrl } from "./controllers/cmd/CmdCenterQueuedCmdCtrl";
import { CmdCenterSetPositionFixedCtrl } from "./controllers/cmd/CmdCenterSetPositionFixedCtrl";
import { CmdCenterSetPositionGatewayCtrl } from "./controllers/cmd/CmdCenterSetPositionGatewayCtrl";
import { CmdCenterShowNearestCtrl } from "./controllers/cmd/CmdCenterShowNearestCtrl";
import { CmdCenterSiteAreaCtrl } from "./controllers/cmd/CmdCenterSiteAreaCtrl";
import { AssetSensorHistoriesDirective } from "./directives/AssetSensorHistoriesDirective";
import { CommandAccelSensorDirective } from "./directives/CommandAccelSensorDirective";
import { CommandActivateDirective } from "./directives/CommandActivateDirective";
import { CommandBuzzDirective } from "./directives/CommandBuzzDirective";
import { CommandClearAlarmsDirective } from "./directives/CommandClearAlarmsDirective";
import { CommandDwellTimeDirective } from "./directives/CommandDwellTimeDirective";
import { CommandGetAlarmsDirective } from "./directives/CommandGetAlarmsDirective";
import { CommandGetPositionDirective } from "./directives/CommandGetPositionDirective";
import { CommandGetThresholdDirective } from "./directives/CommandGetThresholdDirective";
import { CommandResetNetworkDirective } from "./directives/CommandResetNetworkDirective";
import { CommandResetTagDirective } from "./directives/CommandResetTagDirective";
import { CommandResumeDirective } from "./directives/CommandResumeDirective";
import { CommandSetPositionFixedDirective } from "./directives/CommandSetPositionFixedDirective";
import { CommandSetPositionGatewayDirective } from "./directives/CommandSetPositionGatewayDirective";
import { CommandSetReportingIntervalDirective } from "./directives/CommandSetReportingIntervalDirective";
import { CommandSetSecurityDirective } from "./directives/CommandSetSecurityDirective";
import { CommandSetThresholdDirective } from "./directives/CommandSetThresholdDirective";
import { CommandShutdownDirective } from "./directives/CommandShutdownDirective";
import { EditCustomFields } from "./directives/EditCustomFieldsDirective";
import { User } from "oidc-client";
import { AuthHelper } from "./libs/AuthHelper";
import { AboutService } from "./services/AboutService";
import { ClientAppService } from "./services/ClientAppService";
import { MqttClientService } from "./services/MqttClientService";
import { PrintClientService } from "./services/PrintClientService";
import { CompanyService } from "./services/CompanyService";
import { EditClientAppCtrl } from "./controllers/edit/EditClientAppCtrl";
import { EditMqttClientCtrl } from "./controllers/edit/EditMqttClientCtrl";
import { EditPrintClientCtrl } from "./controllers/edit/EditPrintClientCtrl";
import { EditCompanyCtrl } from "./controllers/edit/EditCompanyCtrl";
import { LogoutCtrl } from './controllers/LogoutCtrl';
import { LoggedOutCtrl } from './controllers/LoggedOutCtrl';
import { LicenseExceededCtrl } from './controllers/LicenseExceededCtrl';
import { TokenService } from "./services/TokenService";
import { CommandManager } from "./libs/CommandManager";
import { EditTemplateModel } from './models/edit/EditTemplateModel';
import { AdminCtrl } from './controllers/AdminCtrl';
import { AdminModel } from './models/AdminModel';
import { ServerImportUploadFileCtrl } from './controllers/serverimport/ServerImportUploadFileCtrl';
import { ServerImportMapFieldsCtrl } from './controllers/serverimport/ServerImportMapFieldsCtrl';
import { ServerImportFixErrorsCtrl } from './controllers/serverimport/ServerImportFixErrorsCtrl';
import { ServerImportConfirmCtrl } from './controllers/serverimport/ServerImportConfirmCtrl';
import { ServerImportSummaryCtrl } from './controllers/serverimport/ServerImportSummaryCtrl';
import { ScannerService } from './services/ScannerService';
import { ScannerAdminPagingModel } from './models/paging/ScannerAdminPagingModel';

require('oidc-client')
require('../assets/html/signin-callback.html')
require('../assets/html/silent-callback.html')
require('angular-animate')
require('angular-ui-grid');
require('angular-local-storage')
require('angular-ui-bootstrap')
require('angular-sanitize')
require('ng-csv')
require('angular-simple-logger')
require('ng-notifications-bar')
require('angular-base64-upload')
require('angular-file-saver')
require('ng-file-upload')
require('leaflet')
require('ui-leaflet')
require('leaflet-mouse-position')
require('leaflet.fullscreen')
require('leaflet.awesome-markers')
require('nvd3')
require('../assets/js/angular-csv-import.min')

angular.module('app', [
  'LocalStorageModule',
  'ui.router',
  'ui.grid',
  'ui.grid.selection',
  'ui.grid.autoResize',
  'ui.grid.resizeColumns',
  'ui.grid.pagination',
  'ui.bootstrap',
  'ngSanitize',
  'ngCsv',
  'ngCsvImport',
  'ngAnimate',
  'nemLogging',
  'ui-leaflet',
  'ngNotificationsBar',
  'naif.base64',
  'angular-jwt',
  'ngFileSaver',
  'ngFileUpload'
])
  .config(['$httpProvider', '$stateProvider', '$urlRouterProvider', 'localStorageServiceProvider', 'notificationsConfigProvider', 'jwtOptionsProvider', ($httpProvider: any,
    $stateProvider: any,
    $urlRouterProvider: any,
    localStorageServiceProvider: any,
    notificationsConfigProvider: any,
    jwtOptionsProvider: any) => {
    var renewPromise: any;
    notificationsConfigProvider.setHideDelay(10000);
    //$urlRouterProvider.otherwise("/admin/assets");
    $urlRouterProvider.otherwise(($injector: any, $location: any) => {
      var $state = $injector.get("$state");
      var currState = $state.current;
      $state.go("admin.assets");
    });
    $stateProvider
      .state('admin', {
        url: "/admin",
        template: require('../views/admin.html').default,
        controller: 'AdminCtrl',
        data: {
          requiresLogin: true
        }
      })
      .state('logout', {
        url: "/logout",
        template: require("../views/logout.html").default,
        reloadOnSearch: false,
        controller: 'LogoutCtrl'
      })
      .state('loggedout', {
        url: "/loggedout",
        template: require("../views/loggedout.html").default,
        reloadOnSearch: false,
        controller: 'LoggedOutCtrl'
      })
      .state('licenseexceeded', {
        url: "/licenseexceeded",
        template: require("../views/licenseexceeded.html").default,
        reloadOnSearch: false,
        controller: 'LicenseExceededCtrl'
      })
      .state('loggedin', {
        url: "/logout",
        template: require("../views/logout.html").default,
        reloadOnSearch: false,
        controller: 'LogoutCtrl'
      })
      .state('admin.about', {
        url: "/about",
        template: require("../views/admin.about.html").default,
        controller: 'AboutCtrl',
      })
      .state('admin.editasset', {
        url: "/editasset/{id}",
        reloadOnSearch: false,
        views: {
          '@admin': {
            template: require('../views/admin.editasset.html').default,
            controller: 'EditAssetCtrl'
          },
          'locationHistories@admin.editasset': {
            template: require('../views/assetlocationhistories.html').default,
            controller: 'AssetLocationHistoriesCtrl'
          },
          'checkoutHistories@admin.editasset': {
            template: require('../views/assetcheckouthistories.html').default,
            controller: 'AssetCheckoutHistoriesCtrl'
          },
          'sensors@admin.editasset': {
            template: require('../views/assetsensorhistories.html').default,
            controller: 'AssetSensorHistoriesCtrl'
          }
        },
        params: { id: null }
      })
      .state('admin.editemployee', {
        url: "/editemployee/{id}",
        template: require("../views/admin.editemployee.html").default,
        controller: 'EditEmployeeCtrl',
        params: { id: null }
      })
      .state('admin.showtrack', {
        url: "/showtrack/{id}",
        template: require("../views/admin.showtrack.html").default,
        controller: 'ShowTrackCtrl',
      })
      .state('admin.networkstatus', {
        url: "/networkstatus",
        template: require("../views/admin.networkstatus.html").default,
        reloadOnSearch: false,
        controller: 'NetworkStatusCtrl',
      })
      .state('admin.editlocation', {
        url: "/editlocation/{id}",
        template: require("../views/admin.editlocation.html").default,
        controller: 'EditLocationCtrl',
        params: { id: null }
      })
      .state('admin.editscanner', {
        url: "/editscanner/{id}",
        template: require("../views/admin.editscanner.html").default,
        controller: 'EditScannerCtrl',
        params: { id: null }
      })
      .state('admin.editfixedvtag', {
        url: "/editfixedvtag/{id}",
        template: require("../views/admin.editfixedvtag.html").default,
        controller: 'EditFixedVTagCtrl',
        params: { id: null }
      })
      .state('admin.editplugin', {
        url: "/editplugin/{id}",
        template: require("../views/admin.editplugin.html").default,
        controller: 'EditPluginCtrl',
        params: { id: null }
      })
      .state('admin.editreader', {
        url: "/editreader/{id}",
        template: require("../views/admin.editreader.html").default,
        controller: 'EditReaderCtrl',
        params: { id: null }
      })
      .state('admin.edituser', {
        url: "/edituser/{id}",
        template: require("../views/admin.edituser.html").default,
        controller: 'EditUserCtrl',
        params: { id: null }
      })
      .state('admin.editalertingaction', {
        url: "/editalertingaction/{id}",
        template: require("../views/admin.editalertingaction.html").default,
        controller: 'EditAlertingActionCtrl',
        params: { id: null }
      })
      .state('admin.edittemplate', {
        url: "/edittemplate/{id}",
        template: require("../views/admin.edittemplate.html").default,
        controller: 'EditTemplateCtrl',
        params: { id: null }
      })
      .state('admin.assets', {
        url: "/assets?search&page&pageSize&orderColumn&orderirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'AssetAdminPagingModel'
        },
        data: {
          requiresLogin: true
        }
      })
      .state('admin.audits', {
        url: "/audits?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'AuditAdminPagingModel'
        }
      })
      .state('admin.employees', {
        url: "/employees?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'EmployeeAdminPagingModel'
        }
      })
      .state('admin.locations', {
        url: "/locations?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'LocationAdminPagingModel'
        }
      })
      .state('admin.scanners', {
        url: "/scanners?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'ScannerAdminPagingModel'
        }
      })
      .state('admin.fixedvtags', {
        url: "/fixedvtags?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'FixedVTagAdminPagingModel'
        }
      })
      .state('admin.events', {
        url: "/events?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'EventAdminPagingModel'
        }
      })
      .state('admin.alarms', {
        url: "/alarms?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'AlarmAdminPagingModel'
        }
      })
      .state('admin.queuedcommands', {
        url: "/queuedcommands?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'CommandAdminPagingModel'
        }
      })
      .state('admin.sensorreadings', {
        url: "/sensorreadings?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'SensorAdminPagingModel'
        }
      })
      .state('admin.sensorstats', {
        url: "/sensorstats?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'SensorStatAdminPagingModel'
        }
      })
      .state('admin.alarmacks', {
        url: "/alarmacks?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'AlarmAckAdminPagingModel'
        }
      })
      .state('admin.plugins', {
        url: "/plugins?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'PluginAdminPagingModel'
        }
      })
      .state('admin.printers', {
        url: "/printers?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'PrinterAdminPagingModel'
        }
      })
      .state('admin.printjobs', {
        url: "/printjobs?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'PrintJobAdminPagingModel'
        }
      })
      .state('admin.readers', {
        url: "/readers?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'ReaderAdminPagingModel'
        }
      })
      .state('admin.users', {
        url: "/users?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'UserAdminPagingModel'
        }
      })
      .state('admin.templates', {
        url: "/templates?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'TemplateAdminPagingModel'
        }
      })
      .state('admin.alertingactions', {
        url: "/alertingactions?search&page&pageSize&orderColumn&orderDirection",
        template: require("../views/admin.paging.html").default,
        reloadOnSearch: false,
        controller: 'AdminPagingCtrl',
        resolve: {
          PagingModel: 'AlertingActionAdminPagingModel'
        }
      })
      .state('admin.checkout', {
        url: "/checkout",
        template: require("../views/admin.checkout.html").default,
        reloadOnSearch: false,
        controller: 'CheckoutCtrl',
        resolve: {
          PagingModel: 'CheckoutModel'
        }
      })
      .state('admin.maintenance', {
        url: "/maintenance",
        template: require("../views/admin.scheduledmaintenance.html").default,
        reloadOnSearch: false,
        controller: 'ScheduledMaintenanceCtrl',
      })
      .state('admin.customfieldnames', {
        url: "/customfieldnames",
        template: require("../views/admin.customfieldnames.html").default,
        reloadOnSearch: false,
        controller: 'EditCustomFieldNameCtrl',
      })
      .state('admin.assetpicture', {
        url: "/assetpicture/{id}",
        template: require("../views/admin.assetpicture.html").default,
        reloadOnSearch: false,
        controller: 'AssetPictureCtrl',
        params: { id: null }
      })
      .state('admin.editoptions', {
        url: "/editoptions",
        template: require("../views/admin.editoptions.html").default,
        reloadOnSearch: false,
        controller: 'EditOptionsCtrl',
      })
      .state('admin.reportassets', {
        url: "/reportassets",
        template: require("../views/admin.reportassets.html").default,
        reloadOnSearch: false,
        controller: 'ReportAssetsCtrl',
      })
      .state('admin.reportassetlocationhistory', {
        url: "/reportassetlocationhistory",
        template: require("../views/admin.reportassets.html").default,
        reloadOnSearch: false,
        controller: 'ReportAssetLocationHistoryCtrl',
      })
      .state('admin.reportemployeeworkhours', {
        url: "/reportemployeeworkhours",
        template: require("../views/admin.reportemployeeworkhours.html").default,
        reloadOnSearch: false,
        controller: 'ReportEmployeeWorkHoursCtrl',
      })
      .state('admin.reportgpslocationhistory', {
        url: "/reportgpslocationhistory",
        template: require("../views/admin.reportassets.html").default,
        reloadOnSearch: false,
        controller: 'ReportGpsLocationHistoryCtrl',
      })
      .state('admin.reportlocationhistory', {
        url: "/reportlocationhistory",
        template: require("../views/admin.reportlocationhistory.html").default,
        reloadOnSearch: false,
        controller: 'ReportLocationHistoryCtrl',
      })
      .state('admin.reportemployeelocationhistory', {
        url: "/reportemployeelocationhistory",
        template: require("../views/admin.reportemployeelocationhistory.html").default,
        reloadOnSearch: false,
        controller: 'ReportEmployeeLocationHistoryCtrl',
      })
      .state('admin.reportlocations', {
        url: "/reportlocations",
        template: require("../views/admin.reportlocations.html").default,
        reloadOnSearch: false,
        controller: 'ReportLocationCtrl',
      })
      .state('admin.reportcheckouthistory', {
        url: "/reportcheckouthistory",
        template: require("../views/admin.reportcheckouthistory.html").default,
        reloadOnSearch: false,
        controller: 'ReportCheckoutHistoryCtrl',
      })
      .state('admin.reportmaintenanceschedule', {
        url: "/reportmaintenanceschedule",
        template: require("../views/admin.reportmaintenancehistory.html").default,
        reloadOnSearch: false,
        controller: 'ReportMaintenanceScheduleCtrl',
      })
      .state('admin.reportvtagcommunication', {
        url: "/reportvtagcommunication",
        template: require("../views/admin.reportvtagcommunication.html").default,
        reloadOnSearch: false,
        controller: 'ReportVTagCommunicationCtrl',
      })
      .state('admin.reportlowbattery', {
        url: "/reportlowbattery",
        template: require("../views/admin.reportlowbattery.html").default,
        reloadOnSearch: false,
        controller: 'ReportLowBatteryCtrl',
      })
      .state('admin.displayoptions', {
        url: "/displayoptions",
        template: require("../views/admin.displayoptions.html").default,
        reloadOnSearch: false,
        controller: 'DisplayOptionsCtrl',
      })
      .state('admin.exportasset', {
        url: "/exportasset",
        template: require("../views/admin.export.html").default,
        reloadOnSearch: false,
        controller: 'ExportCtrl',
        resolve: {
          ExportModel: 'AssetExportModel'
        }
      })
      .state('admin.exportaudit', {
        url: "/exportaudit",
        template: require("../views/admin.export.html").default,
        reloadOnSearch: false,
        controller: 'ExportCtrl',
        resolve: {
          ExportModel: 'AuditExportModel'
        }
      })
      .state('admin.exportlocation', {
        url: "/exportlocation",
        template: require("../views/admin.export.html").default,
        reloadOnSearch: false,
        controller: 'ExportCtrl',
        resolve: {
          ExportModel: 'LocationExportModel'
        }
      })
      .state('admin.exportfixedvtag', {
        url: "/exportfixed",
        template: require("../views/admin.export.html").default,
        reloadOnSearch: false,
        controller: 'ExportCtrl',
        resolve: {
          ExportModel: 'FixedExportModel'
        }
      })
      .state('admin.locationimport', {
        url: "/locationimport",
        abstract: true,
        template: '<ui-view/>'
      })
      .state('admin.locationimport.fileupload', {
        url: "",
        template: require("../views/admin.import.uploadfile.html").default,
        controller: 'ImportUploadFileCtrl',
        resolve: {
          ImportModel: 'LocationImportModel'
        }
      })
      .state('admin.locationimport.mapfields', {
        url: "/mapfields",
        template: require("../views/admin.import.mapfields.html").default,
        reloadOnSearch: false,
        controller: 'ImportMapFieldsCtrl',
        resolve: {
          ImportModel: 'LocationImportModel'
        }
      })
      .state('admin.locationimport.fixerrors', {
        url: "/fixerrors",
        template: require("../views/admin.import.fixerrors.html").default,
        reloadOnSearch: false,
        controller: 'ImportFixErrorsCtrl',
        resolve: {
          ImportModel: 'LocationImportModel'
        }
      })
      .state('admin.locationimport.confirm', {
        url: "/confirm",
        template: require("../views/admin.import.confirmimport.html").default,
        reloadOnSearch: false,
        controller: 'ImportConfirmCtrl',
        resolve: {
          ImportModel: 'LocationImportModel'
        }
      })
      .state('admin.locationimport.summary', {
        url: "/summary",
        template: require("../views/admin.import.summary.html").default,
        reloadOnSearch: false,
        controller: 'ImportSummaryCtrl',
        resolve: {
          ImportModel: 'LocationImportModel'
        }
      })
      .state('admin.serverassetimport', {
        url: "/serverassetimport",
        abstract: true,
        template: '<ui-view/>'
      })
      .state('admin.serverassetimport.fileupload', {
        url: "",
        template: require("../views/server.import.uploadfile.html").default,
        controller: 'ServerImportUploadFileCtrl',
        resolve: {
          ImportModel: 'ServerAssetImportModel'
        }
      })
      .state('admin.serverassetimport.mapfields', {
        url: "",
        template: require("../views/server.import.mapfields.html").default,
        controller: 'ServerImportMapFieldsCtrl',
        resolve: {
          ImportModel: 'ServerAssetImportModel'
        }
      })
      .state('admin.serverassetimport.fixerrors', {
        url: "",
        template: require("../views/server.import.fixerrors.html").default,
        controller: 'ServerImportFixErrorsCtrl',
        resolve: {
          ImportModel: 'ServerAssetImportModel'
        }
      })
      .state('admin.serverassetimport.confirm', {
        url: "",
        template: require("../views/server.import.confirmimport.html").default,
        controller: 'ServerImportConfirmCtrl',
        resolve: {
          ImportModel: 'ServerAssetImportModel'
        }
      })
      .state('admin.serverassetimport.summary', {
        url: "",
        template: require("../views/server.import.summary.html").default,
        controller: 'ServerImportSummaryCtrl',
        resolve: {
          ImportModel: 'ServerAssetImportModel'
        }
      })


      .state('admin.serverlocationimport', {
        url: "/serverlocationimport",
        abstract: true,
        template: '<ui-view/>'
      })
      .state('admin.serverlocationimport.fileupload', {
        url: "",
        template: require("../views/server.import.uploadfile.html").default,
        controller: 'ServerImportUploadFileCtrl',
        resolve: {
          ImportModel: 'ServerLocationImportModel'
        }
      })
      .state('admin.serverlocationimport.mapfields', {
        url: "",
        template: require("../views/server.import.mapfields.html").default,
        controller: 'ServerImportMapFieldsCtrl',
        resolve: {
          ImportModel: 'ServerLocationImportModel'
        }
      })
      .state('admin.serverlocationimport.fixerrors', {
        url: "",
        template: require("../views/server.import.fixerrors.html").default,
        controller: 'ServerImportFixErrorsCtrl',
        resolve: {
          ImportModel: 'ServerLocationImportModel'
        }
      })
      .state('admin.serverlocationimport.confirm', {
        url: "",
        template: require("../views/server.import.confirmimport.html").default,
        controller: 'ServerImportConfirmCtrl',
        resolve: {
          ImportModel: 'ServerLocationImportModel'
        }
      })
      .state('admin.serverlocationimport.summary', {
        url: "",
        template: require("../views/server.import.summary.html").default,
        controller: 'ServerImportSummaryCtrl',
        resolve: {
          ImportModel: 'ServerLocationImportModel'
        }
      })


      .state('admin.assetimport', {
        url: "/assetimport",
        abstract: true,
        template: '<ui-view/>'
      })
      .state('admin.assetimport.fileupload', {
        url: "",
        template: require("../views/admin.import.uploadfile.html").default,
        controller: 'ImportUploadFileCtrl',
        resolve: {
          ImportModel: 'AssetImportModel'
        }
      })
      .state('admin.assetimport.mapfields', {
        url: "/mapfields",
        template: require("../views/admin.import.mapfields.html").default,
        reloadOnSearch: false,
        controller: 'ImportMapFieldsCtrl',
        resolve: {
          ImportModel: 'AssetImportModel'
        }
      })
      .state('admin.assetimport.fixerrors', {
        url: "/fixerrors",
        template: require("../views/admin.import.fixerrors.html").default,
        reloadOnSearch: false,
        controller: 'ImportFixErrorsCtrl',
        resolve: {
          ImportModel: 'AssetImportModel'
        }
      })
      .state('admin.assetimport.confirm', {
        url: "/confirm",
        template: require("../views/admin.import.confirmimport.html").default,
        reloadOnSearch: false,
        controller: 'ImportConfirmCtrl',
        resolve: {
          ImportModel: 'AssetImportModel'
        }
      })
      .state('admin.assetimport.summary', {
        url: "/summary",
        template: require("../views/admin.import.summary.html").default,
        reloadOnSearch: false,
        controller: 'ImportSummaryCtrl',
        resolve: {
          ImportModel: 'AssetImportModel'
        }
      })
      .state('cmdcenter', {
        url: "/cmdcenter",
        template: require("../views/cmdcenter.html").default,
        controller: 'AdminCtrl',
        data: {
          requiresLogin: true
        }
      })
      .state('cmdcenter.map', {
        url: "/map",
        template: require("../views/cmdcenter.map.html").default,
        reloadOnSearch: false,
        controller: 'CmdCenterMapCtrl'
      })
      .state('cmdcenter.sitearea', {
        url: "/sitearea?mapSiteID&mapAreaId",
        template: require("../views/cmdcenter.sitearea.html").default,
        controller: 'CmdCenterSiteAreaCtrl',
      })
      .state('cmdcenter.editsite', {
        url: "/editsite?id",
        template: require("../views/cmdcenter.editsite.html").default,
        controller: 'CmdCenterEditSiteCtrl',
      })
      .state('cmdcenter.editarea', {
        url: "/editarea?id&mapSiteID",
        template: require("../views/cmdcenter.editarea.html").default,
        controller: 'CmdCenterEditAreaCtrl',
      })
      .state('cmdcenter.assetcommands', {
        url: "/assetcommands",
        template: require("../views/cmdcenter.assetcommands.html").default,
        controller: 'CmdCenterAssetCmdCtrl',
      })
      .state('cmdcenter.networkcommands', {
        url: "/networkcommands",
        template: require("../views/cmdcenter.networkcommands.html").default,
        controller: 'CmdCenterNetworkCmdCtrl',
      })
      .state('cmdcenter.queuedcommands', {
        url: "/queuedcommands",
        template: require("../views/cmdcenter.queuedcommands.html").default,
        controller: 'CmdCenterQueuedCmdCtrl',
      })
      .state('cmdcenter.editoptions', {
        url: "/editoptions",
        template: require("../views/cmdcenter.options.html").default,
        controller: 'CmdCenterEditOptionsCtrl',
      });
    jwtOptionsProvider.config({
      unauthenticatedRedirector: ['$state', 'TokenService', 'AuthService', function ($state: any, tokenService: any, authService: any) {
        //tokenService.refreshToken
        //TOKEN FAILED.. FORWARD TO THE AUTH SERVER..
        // https://assetworx.infinidtech.com/api/authentication/signin?response_type=code&state=&client_id=postman&scope=&redirect_uri=https://assetworx.infinidtech.com
        // app redirects to https://assetworx.infinidtech.com?code=ABC123
        //  app first inititalizes, call get_token_from_code()
        console.log("****************************************unauthenticatedRedirector. redirecting.");
        $state.go('login');
      }],
      whiteListedDomains: ['assetworx.infinidtech.com', 'localhost'],
      //unauthenticatedRedirectPath: '/login',
      tokenGetter: ['options', 'jwtHelper', '$http', '$state', 'AuthService', function (options: any, jwtHelper: any, $http: any, $state: any, authService: any) {
        if (renewPromise) {
          console.log("returning refresh promise");
          return renewPromise;
        }
        return authService.getUser().then((user: User): any => {
          if (user == null) {
            console.log("*********user null.. redirecting..");
            //authService.login();
            $state.go('login');
          }
          else if (user.expired) {
            $state.go('login');
          }
          else {
            return user.access_token;

          }
        });

      }]
    });
    $httpProvider.interceptors.push('jwtInterceptor');
  }])
  //services
  .service('EditMaintenanceHandler_EditAsset', EditMaintenanceHandler_EditAsset)
  .service('EditMaintenanceHandler_NewAsset', EditMaintenanceHandler_NewAsset)
  .service('AboutService', AboutService)
  .service('AlarmAckService', AlarmAckService)
  .service('AlarmService', AlarmService)
  .service('AlertingActionService', AlertingActionService)
  .service('AntennaService', AntennaService)
  .service('ApplicationSettingService', ApplicationSettingService)
  .service('AssetService', AssetService)
  .service('CheckoutHistoryService', CheckoutHistoryService)
  .service('ClientAppService', ClientAppService)
  .service('MqttClientService', MqttClientService)
  .service('PrintClientService', PrintClientService)
  .service('CompanyService', CompanyService)
  .service('ConfigSettingService', ConfigSettingService)
  .service('CustomFieldNameService', CustomFieldNameService)
  .service('EmployeeService', EmployeeService)
  .service('AuditService', AuditService)
  .service('EventService', EventService)
  .service('FileDataService', FileDataService)
  .service('FixedVTagService', FixedVTagService)
  .service('GpsLocationHistoryService', GpsLocationHistoryService)
  .service('GridBookmarkService', GridBookmarkService)
  .service('LocationHistoryService', LocationHistoryService)
  .service('EmployeeLocationHistoryService', EmployeeLocationHistoryService)
  .service('LocationService', LocationService)
  .service('ScannerService', ScannerService)
  .service('MaintenanceHistoryService', MaintenanceHistoryService)
  .service('MapAreaService', MapAreaService)
  .service('MapSiteService', MapSiteService)
  .service('NotificationService', NotificationService)
  .service('PluginService', PluginService)
  .service('PrinterService', PrinterService)
  .service('PrintJobService', PrintJobService)
  .service('QueuedCommandService', QueuedCommandService)
  .service('ReaderService', ReaderService)
  .service('SensorService', SensorService)
  .service('SensorStatService', SensorStatService)
  .service('ServerStatusService', ServerStatusService)
  .service('TemplateService', TemplateService)
  .service('UserService', UserService)
  .service('AuthService', AuthService)
  //view models
  .service('CheckoutModel', CheckoutModel)
  .service('DisplayOptionsModel', DisplayOptionsModel)
  .service('EditCustomFieldNameModel', EditCustomFieldNameModel)
  .service('EditOptionsModel', EditOptionsModel)
  .service('ScheduledMaintenanceModel', ScheduledMaintenanceModel)
  .service('ShowTrackModel', ShowTrackModel)
  //report models
  .service('ReportAssetLocationHistoryModel', ReportAssetLocationHistoryModel)
  .service('ReportGpsLocationHistoryModel', ReportGpsLocationHistoryModel)
  .service('ReportAssetsModel', ReportAssetsModel)
  .service('ReportCheckoutHistoryModel', ReportCheckoutHistoryModel)
  .service('ReportEmployeeWorkHoursModel', ReportEmployeeWorkHoursModel)
  .service('ReportEmployeeLocationHistoryModel', ReportEmployeeLocationHistoryModel)
  .service('ReportLocationHistoryModel', ReportLocationHistoryModel)
  .service('ReportLocationModel', ReportLocationModel)
  .service('ReportLowBatteryModel', ReportLowBatteryModel)
  .service('ReportMaintenanceScheduleModel', ReportMaintenanceScheduleModel)
  .service('ReportVTagCommunicationModel', ReportVTagCommunicationModel)
  //paging models
  .service('AlarmAckAdminPagingModel', AlarmAckAdminPagingModel)
  .service('AlarmAdminPagingModel', AlarmAdminPagingModel)
  .service('AlertingActionAdminPagingModel', AlertingActionAdminPagingModel)
  .service('AssetAdminPagingModel', AssetAdminPagingModel)
  .service('CommandAdminPagingModel', CommandAdminPagingModel)
  .service('EmployeeAdminPagingModel', EmployeeAdminPagingModel)
  .service('AuditAdminPagingModel', AuditAdminPagingModel)
  .service('EventAdminPagingModel', EventAdminPagingModel)
  .service('FixedVTagAdminPagingModel', FixedVTagAdminPagingModel)
  .service('LocationAdminPagingModel', LocationAdminPagingModel)
  .service('ScannerAdminPagingModel', ScannerAdminPagingModel)
  .service('PluginAdminPagingModel', PluginAdminPagingModel)
  .service('PrinterAdminPagingModel', PrinterAdminPagingModel)
  .service('PrintJobAdminPagingModel', PrintJobAdminPagingModel)
  .service('ReaderAdminPagingModel', ReaderAdminPagingModel)
  .service('SensorAdminPagingModel', SensorAdminPagingModel)
  .service('SensorStatAdminPagingModel', SensorStatAdminPagingModel)
  .service('TemplateAdminPagingModel', TemplateAdminPagingModel)
  .service('TokenService', TokenService)
  .service('UserAdminPagingModel', UserAdminPagingModel)
  //server import models
  .service('ServerAssetImportModel', ServerAssetImportModel)
  .service('ServerLocationImportModel', ServerLocationImportModel)
  //import models
  .service('AssetImportModel', AssetImportModel)
  .service('LocationImportModel', LocationImportModel)
  //export models
  .service('AssetExportModel', AssetExportModel)
  .service('AuditExportModel', AuditExportModel)
  .service('FixedExportModel', FixedExportModel)
  .service('LocationExportModel', LocationExportModel)
  //edit models
  .service('AssetLocationHistoriesModel', AssetLocationHistoriesModel)
  .service('CustomFieldNameModel', CustomFieldNameModel)
  .service('EditAlertingActionModel', EditAlertingActionModel)
  .service('EditAssetModel', EditAssetModel)
  .service('EditEmployeeModel', EditEmployeeModel)
  .service('EditFixedVTagModel', EditFixedVTagModel)
  .service('EditLocationModel', EditLocationModel)
  .service('EditScannerModel', EditScannerModel)
  .service('EditPluginModel', EditPluginModel)
  .service('EditPrinterModel', EditPrinterModel)
  .service('EditReaderModel', EditReaderModel)
  .service('EditUserModel', EditUserModel)
  .service('EditTemplateModel', EditTemplateModel)
  .service('PickChildModel', PickChildModel)
  //cmd models
  .service('CmdCenterAssetCmdModel', CmdCenterAssetCmdModel)
  .service('CmdCenterEditAreaModel', CmdCenterEditAreaModel)
  .service('CmdCenterEditOptionsModel', CmdCenterEditOptionsModel)
  .service('CmdCenterEditSiteModel', CmdCenterEditSiteModel)
  .service('CmdCenterMapModel', CmdCenterMapModel)
  .service('CmdCenterQueuedCmdModel', CmdCenterQueuedCmdModel)
  .service('CmdCenterSetPositionFixedModel', CmdCenterSetPositionFixedModel)
  .service('CmdCenterSetPositionGatewayModel', CmdCenterSetPositionGatewayModel)
  .service('CmdCenterShowNearestModel', CmdCenterShowNearestModel)
  .service('CmdCenterSiteAreaModel', CmdCenterSiteAreaModel)
  //helpers
  .service('AuthHelper', AuthHelper)
  .service('CommandManager', CommandManager)
  .service('AdminModel', AdminModel)
  //view ctrl
  .controller('AboutCtrl', AboutCtrl)
  .controller('AssetCheckoutHistoriesCtrl', AssetCheckoutHistoriesCtrl)
  .controller('AssetLocationHistoriesCtrl', AssetLocationHistoriesCtrl)
  .controller('AssetSensorHistoriesCtrl', AssetSensorHistoriesCtrl)
  .controller('GraphCtrl', GraphCtrl)
  .controller('ShowTrackCtrl', ShowTrackCtrl)
  .controller('NetworkStatusCtrl', NetworkStatusCtrl)
  //task ctrl
  .controller('BatchMoveCtrl', BatchMoveCtrl)
  .controller('CheckoutCtrl', CheckoutCtrl)
  .controller('DisplayOptionsCtrl', DisplayOptionsCtrl)
  .controller('EditCustomFieldNameCtrl', EditCustomFieldNameCtrl)
  .controller('EditOptionsCtrl', EditOptionsCtrl)
  .controller('PrintCtrl', PrintCtrl)
  .controller('AssetPictureCtrl', AssetPictureCtrl)
  .controller('ScheduledMaintenanceCtrl', ScheduledMaintenanceCtrl)
  //reports ctrl
  .controller('ReportGpsLocationHistoryCtrl', ReportGpsLocationHistoryCtrl)
  .controller('ReportAssetLocationHistoryCtrl', ReportAssetLocationHistoryCtrl)
  .controller('ReportAssetsCtrl', ReportAssetsCtrl)
  .controller('ReportCheckoutHistoryCtrl', ReportCheckoutHistoryCtrl)
  .controller('ReportEmployeeWorkHoursCtrl', ReportEmployeeWorkHoursCtrl)
  .controller('ReportLocationCtrl', ReportLocationCtrl)
  .controller('ReportEmployeeLocationHistoryCtrl', ReportEmployeeLocationHistoryCtrl)
  .controller('ReportLocationHistoryCtrl', ReportLocationHistoryCtrl)
  .controller('ReportLowBatteryCtrl', ReportLowBatteryCtrl)
  .controller('ReportMaintenanceScheduleCtrl', ReportMaintenanceScheduleCtrl)
  .controller('ReportVTagCommunicationCtrl', ReportVTagCommunicationCtrl)
  //server import ctrl
  .controller('ServerImportUploadFileCtrl', ServerImportUploadFileCtrl)
  .controller('ServerImportMapFieldsCtrl', ServerImportMapFieldsCtrl)
  .controller('ServerImportFixErrorsCtrl', ServerImportFixErrorsCtrl)
  .controller('ServerImportConfirmCtrl', ServerImportConfirmCtrl)
  .controller('ServerImportSummaryCtrl', ServerImportSummaryCtrl)
  //import ctrl
  .controller('ImportConfirmCtrl', ImportConfirmCtrl)
  .controller('ImportFixErrorsCtrl', ImportFixErrorsCtrl)
  .controller('ImportMapFieldsCtrl', ImportMapFieldsCtrl)
  .controller('ImportSummaryCtrl', ImportSummaryCtrl)
  .controller('ImportUploadFileCtrl', ImportUploadFileCtrl)
  //paging ctrl
  .controller('AdminPagingCtrl', AdminPagingCtrl)
  //export ctrl
  .controller('ExportCtrl', ExportCtrl)
  //edit ctrl
  .controller('EditAlertingActionCtrl', EditAlertingActionCtrl)
  .controller('EditAssetCtrl', EditAssetCtrl)
  .controller('EditEmployeeCtrl', EditEmployeeCtrl)
  .controller('EditClientAppCtrl', EditClientAppCtrl)
  .controller('EditMqttClientCtrl', EditMqttClientCtrl)
  .controller('EditPrintClientCtrl', EditPrintClientCtrl)
  .controller('EditCompanyCtrl', EditCompanyCtrl)
  .controller('EditFixedVTagCtrl', EditFixedVTagCtrl)
  .controller('EditLocationCtrl', EditLocationCtrl)
  .controller('EditScannerCtrl', EditScannerCtrl)
  .controller('EditMaintenanceCtrl', EditMaintenanceCtrl)
  .controller('EditPasswordCtrl', EditPasswordCtrl)
  .controller('EditPluginCtrl', EditPluginCtrl)
  .controller('EditPrinterCtrl', EditPrinterCtrl)
  .controller('EditReaderCtrl', EditReaderCtrl)
  .controller('EditTemplateCtrl', EditTemplateCtrl)
  .controller('EditUserCtrl', EditUserCtrl)
  .controller('PickChildCtrl', PickChildCtrl)
  //cmd ctrl
  .controller('CmdCenterAssetCmdCtrl', CmdCenterAssetCmdCtrl)
  .controller('CmdCenterEditAreaCtrl', CmdCenterEditAreaCtrl)
  .controller('CmdCenterEditOptionsCtrl', CmdCenterEditOptionsCtrl)
  .controller('CmdCenterEditSiteCtrl', CmdCenterEditSiteCtrl)
  .controller('CmdCenterMapCtrl', CmdCenterMapCtrl)
  .controller('CmdCenterNetworkCmdCtrl', CmdCenterNetworkCmdCtrl)
  .controller('CmdCenterQueuedCmdCtrl', CmdCenterQueuedCmdCtrl)
  .controller('CmdCenterSetPositionFixedCtrl', CmdCenterSetPositionFixedCtrl)
  .controller('CmdCenterSetPositionGatewayCtrl', CmdCenterSetPositionGatewayCtrl)
  .controller('CmdCenterShowNearestCtrl', CmdCenterShowNearestCtrl)
  .controller('CmdCenterSiteAreaCtrl', CmdCenterSiteAreaCtrl)
  //logout ctrl
  .controller('LogoutCtrl', LogoutCtrl)
  .controller('LoggedOutCtrl', LoggedOutCtrl)
  .controller('LicenseExceededCtrl', LicenseExceededCtrl)
  .controller('AdminCtrl', AdminCtrl)
  //directives
  .directive('assetSensorHistories', AssetSensorHistoriesDirective.factory())
  .directive('commandAccelSensor', CommandAccelSensorDirective.factory())
  .directive('commandActivate', CommandActivateDirective.factory())
  .directive('commandBuzz', CommandBuzzDirective.factory())
  .directive('commandClearAlarms', CommandClearAlarmsDirective.factory())
  .directive('commandDwellTime', CommandDwellTimeDirective.factory())
  .directive('commandGetAlarms', CommandGetAlarmsDirective.factory())
  .directive('commandGetPosition', CommandGetPositionDirective.factory())
  .directive('commandGetThreshold', CommandGetThresholdDirective.factory())
  .directive('commandResetNetwork', CommandResetNetworkDirective.factory())
  .directive('commandResetTag', CommandResetTagDirective.factory())
  .directive('commandResume', CommandResumeDirective.factory())
  .directive('commandSetPositionFixed', CommandSetPositionFixedDirective.factory())
  .directive('commandSetPositionGateway', CommandSetPositionGatewayDirective.factory())
  .directive('commandSetReportingInterval', CommandSetReportingIntervalDirective.factory())
  .directive('commandSetSecurity', CommandSetSecurityDirective.factory())
  .directive('commandSetThreshold', CommandSetThresholdDirective.factory())
  .directive('commandShutdown', CommandShutdownDirective.factory())
  .directive('editCustomFields', EditCustomFields.factory())
  .run(['$rootScope', '$state', 'ApplicationSettingService', 'AuthService', 'TokenService', 'localStorageService', 'NotificationService', 'AuthHelper', 'AdminModel', function ($rootScope: any,
    $state: any,
    applicationSettingService: ApplicationSettingService,
    authService: AuthService, tokenService: TokenService,
    locStorage: angular.local.storage.ILocalStorageService,
    notificationService: NotificationService,
    authHelper: AuthHelper,
    adminModel: AdminModel) {
    $rootScope.loading = true;
    $rootScope.bodyClass = 'loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading loading';
    //$rootScope.bodyClass = 'loading';
    // Etc. Initialize here.
    console.log("!!!!!!!!!!!!!!!!!!!!!!!!!app.run started");
    applicationSettingService.getAuthenticationData().then((data) => {

      if (data != null)
        authService.setAuthenticationServer(data.authenticationServer, data.webClientID, data.webClientSecret, data.useLocalStorage);
      let myVal = locStorage.get("tokenStorageType");
      locStorage.set("tokenStorageType", "session");
      console.log("!!!!!!!!!!!!!!!!!app.run. got auth=" + data);
      tokenService.getUsername().then((data) => {
        adminModel.username = data;
      });
      applicationSettingService.getCached()
        .then(() => {
          console.log("!!!!!!!!!!!!!!!!!!!!!!!!!app.run completed");
          $rootScope.loading = false;
          authHelper.startMonitoring();
          //spinnerService.closeAll();
        })
        .catch((exc) => {
          console.log("!!!!!!!!!!!!!!!!!!!!!!!!!app.run exception:" + exc);
          var msg: string = exc;
          $rootScope.loading = false;
          //if (msg.startsWith("License seats exceeded.")) {                        
          //    $state.go('licenseexceeded');
          //} else if (msg.startsWith("You are not logged in.")) {
          //    $state.go('loggedout');
          //}
        });
    })
  }]);
